<template>
  <div class="rms-order-food">
    <a-spin :spinning="loading">
      <a-layout style="height:calc(100vh - 125px)">
        <a-layout-sider style="background:#fff;" :width="550">
          <div class="rms-order-wraper">
            <div class="rms-order-info">
              <div class="rms-order-header">
                <div class="text-cell-group">
                  <div class="text-cell-item">
                    <label>当前台号：</label>
                    <span>
                      <a-tag
                        color="#f60"
                        style="font-size:12px;margin:0 2px 2px 0"
                        v-for="(name, index) in tbaleNames"
                        :key="index"
                      >
                        {{ name }}
                      </a-tag></span
                    >
                  </div>
                  <div class="text-cell-item">
                    <label>开单时间：</label>
                    <span>{{ orderData.CheckInTime }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label
                      >人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数：</label
                    >
                    <span>{{ orderData.PersonCount }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label>桌台状态：</label>
                    <span>
                      <a-badge
                        :status="
                          OrderStatus == 1
                            ? 'processing'
                            : OrderStatus == 2
                            ? 'success'
                            : OrderStatus == 12
                            ? 'warning'
                            : 'error'
                        "
                        :text="OrderStatusName"
                      />
                    </span>
                  </div>
                  <div class="text-cell-item">
                    <label>客源类型：</label>
                    <span>{{ orderData.GuestSourceName }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label
                      >单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</label
                    >
                    <span class="edit-link" @click="editInfo"
                      >{{ orderData.No }} <a-icon type="edit"
                    /></span>
                  </div>
                  <div class="text-cell-item">
                    <label
                      >会&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;员：</label
                    >
                    <span>{{ orderData.MemberName }}</span>
                    <a-button
                      type="link"
                      size="small"
                      @click="handleMemberCardNo"
                      v-if="OrderStatus != 2"
                    >
                      {{ orderData.MemberCardId ? "修改" : "添加" }}
                      <a-icon
                        :type="orderData.MemberCardId ? 'edit' : 'plus'"
                      />
                    </a-button>
                  </div>
                  <div class="text-cell-item">
                    <span v-if="Number(orderData.Discount) > 0">
                      <a-tag color="orange" style="font-size:14px;">
                        折&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;扣：{{
                          orderData.Discount
                        }}
                        折
                      </a-tag></span
                    >
                  </div>
                </div>
              </div>
              <div class="rms-order-table">
                <data-grid
                  ref="orderTable"
                  size="middle"
                  :columns="orderColumns"
                  v-model="orderFoodList"
                  :pagination="false"
                  :props="orderTableProps"
                  :scroll="tableScroll"
                  :locale="{ emptyText: '请选择右侧菜品点菜' }"
                  rowKey="_id"
                  @selectRow="onOrderTableSelectedRow"
                >
                  <template slot="name" slot-scope="text, row">
                    <div class="food-title multi-line" style="text-align:left;">
                      <div>
                        <span class="icon-list">
                          <i
                            v-if="row.Id"
                            class="icon-text"
                            style="background:rgb(135, 208, 104);color:#fff;"
                            ><a-icon type="check"
                          /></i>
                          <i
                            v-if="!row.Id"
                            class="icon-text"
                            style="background:#1890ff;color:#fff;"
                            ><a-icon type="plus"
                          /></i>
                          <a-popover placement="bottomLeft" title="套餐菜品">
                            <template slot="content">
                              <div
                                v-for="foodItem in row.PackDetails"
                                :key="foodItem.Id"
                                class="flex"
                              >
                                <div class="flex-item">{{ foodItem.Name }}</div>
                                <div>{{ foodItem.Quantity }}</div>
                              </div>
                            </template>
                            <i
                              v-if="row.IsPack"
                              class="icon-text"
                              style="background:#f90;color:#fff;cursor: pointer;"
                              >套</i
                            >
                          </a-popover>
                        </span>
                        {{ text }}
                      </div>
                      <div
                        v-if="row.PracticeDesc || row.CookingMethodDesc"
                        class="text-less"
                      >
                        「做法」{{ row.PracticeDesc
                        }}{{ row.CookingMethodDesc }}
                      </div>
                    </div>
                  </template>
                </data-grid>
                <div v-if="showFoodCookingMethod" class="cooking-method quick">
                  <ul>
                    <li
                      v-for="item in foodCookingMethod"
                      :key="item.Id"
                      :class="[
                        {
                          check:
                            currentSelectedRow &&
                            currentSelectedRow.CookingMethodIds &&
                            currentSelectedRow.CookingMethodIds.includes(
                              item.Id
                            )
                        }
                      ]"
                      @click="onFoodCookingMethodClick(item)"
                    >
                      {{ item.Text }}
                      <a-icon type="check" class="check-icon" />
                    </li>
                    <li @click="addMethod">
                      手写
                    </li>
                    <li
                      v-if="
                        foodCookingMethodAll && foodCookingMethodAll.length > 4
                      "
                      @click="openMoreFoodCookingMethodModal"
                    >
                      更多
                    </li>
                  </ul>
                  <a
                    class="cooking-method-close_button"
                    @click="closeCookingMethodBox"
                  >
                    <a-icon type="close" />
                  </a>
                </div>
              </div>
              <div class="rms-order-total">
                <div class="text-cell-group current-table">
                  <div class="text-cell-item">
                    <label>菜品数量：</label>
                    <span>{{
                      totalData.quantity ? totalData.quantity : 0
                    }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label>单桌金额：</label>
                    <span class="rms-price"
                      >￥{{
                        totalData.totalPrice ? totalData.totalPrice : "0.00"
                      }}</span
                    >
                  </div>
                  <div class="text-cell-item">
                    <label>单桌总金额：</label>
                    <span class="rms-price"
                      >￥{{
                        totalData.totalPrice ? totalData.totalPrice : "0.00"
                      }}</span
                    >
                  </div>
                  <div class="text-cell-item">
                    <label>单桌折后金额：</label>
                    <span class="rms-price"
                      ><b
                        >￥{{
                          totalData.finalPrice ? totalData.finalPrice : "0.00"
                        }}</b
                      ></span
                    >
                  </div>
                </div>
                <div class="text-cell-group">
                  <div class="text-cell-item">
                    <label>订单总金额：</label>
                    <span class="rms-price"
                      >￥{{ totalData.orderTotalAmount }}</span
                    >
                  </div>
                  <div class="text-cell-item">
                    <label>订单折后金额：</label>
                    <span class="rms-price"
                      ><b>￥{{ totalData.orderFinalAmount }}</b></span
                    >
                  </div>
                </div>
                <div class="text-cell-group">
                  <div class="text-cell-item">
                    <label>订单抹零金额：</label>
                    <span class="rms-price"
                      >￥{{ orderData.FreeRemnantAmount }}</span
                    >
                  </div>
                  <div class="text-cell-item">
                    <label>订单结算金额：</label>
                    <span class="rms-price"
                      ><b>￥{{ totalData.orderSettleAmount }}</b></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="rms-order-actions">
              <div class="rms-order-actions_box">
                <!-- <a>列印单</a> -->
                <!-- <a>修改人数</a> -->
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="addQuantity"
                  >+1</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="cutQuantity"
                  >-1</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="editQuantity"
                  >数量</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="delRow"
                  >删除</a
                >
                <a
                  :class="{
                    disabled:
                      (!currentSelectedRow._id && !currentSelectedRow.Id) ||
                      currentSelectedRow.IsUnconfirmed ||
                      OrderStatus == 2
                  }"
                  @click="editPrice"
                  >改价</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="setShowFoodCookingMethod"
                  >做法</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow.Id ||
                      OrderStatus == 2 ||
                      OrderStatus == 4 ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="returnFoods"
                  >退菜</a
                >
                <a
                  @click="giveFoods"
                  :class="{
                    disabled:
                      currentSelectedRow.Id ||
                      !currentSelectedRow._id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  >赠送</a
                >
                <a
                  @click="editPack"
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      !currentSelectedRow.IsPack ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  >修改套餐</a
                >
                <a
                  @click="confirmDish"
                  :class="{
                    disabled: !hasUnConfirm
                  }"
                  >确认菜品</a
                >
                <a @click="moreOpertion">更多操作</a>
              </div>
            </div>
          </div>
        </a-layout-sider>
        <a-layout-content style="padding: 10px 0 0 10px!important;">
          <FoodSelect
            ref="FoodSelect"
            :isMemberOrder="isMemberOrder"
            @foodClick="addFood"
          />
          <div class="footer-action-box" style="padding-right:10px;">
            <a-dropdown placement="topCenter">
              <a-button type="primary" style="float:left">打印出品</a-button>
              <a-menu slot="overlay" class="printer-option">
                <a-button type="primary" @click="onPrinter(1)" block
                  >厨单</a-button
                >
                <a-button type="primary" @click="onPrinter(0)" block
                  >总单加厨单</a-button
                >
                <a-dropdown v-model="showFoods" placement="topRight">
                  <a-menu slot="overlay" class="printer-foods-option">
                    打印厨单(指定菜品)
                    <data-grid
                      ref="printerTable"
                      size="small"
                      :columns="orderColumns"
                      v-model="printerFoodList"
                      :pagination="false"
                      :rowSelect="true"
                      :rowTriggerSelect="true"
                      :props="printerTableProps"
                      :locale="{ emptyText: '请选择右侧菜品点菜' }"
                      rowKey="Id"
                    >
                    </data-grid>
                    <a-button type="primary" @click="selectFoods" block
                      >确认打印</a-button
                    >
                  </a-menu>
                  <a-button type="primary" @click="showFoods = true" block
                    >厨单(指定菜品)</a-button
                  >
                </a-dropdown>
              </a-menu>
            </a-dropdown>
            <a-dropdown placement="topCenter">
              <a-button type="primary" style="float:left">打单</a-button>
              <a-menu slot="overlay" class="printer-option">
                <a-button
                  type="primary"
                  @click="onPrintReport('9921', '列印单')"
                  block
                  >列印单</a-button
                >
                <a-button
                  type="primary"
                  @click="onPrintReport('9922', '列印全单')"
                  block
                  >列印全单</a-button
                >
                <a-button
                  type="primary"
                  @click="onPrintReport('9923', '预结单')"
                  block
                  >预结单</a-button
                >
                <a-button
                  type="primary"
                  @click="onPrintReport('9924', '结账单')"
                  block
                  >结账单</a-button
                >
              </a-menu>
            </a-dropdown>
            <a-button
              class="cancel-btn"
              style="float:left"
              v-if="orderData.IsOnlinePay"
              @click="getOrderQuery"
              >微信客人自结记录</a-button
            >
            <a-button type="primary" @click="onSubmit(1)" v-if="canOrder"
              >下单</a-button
            >
            <a-button type="primary" @click="onSubmit(2)" v-if="canOrder"
              >下单并打印</a-button
            >
            <a-button
              :disabled="
                !(
                  openTableList &&
                  openTableList.filter(el => el.OrderStatus != 2).length > 1
                )
              "
              type="primary"
              v-if="canOrder"
              @click="multTableOrder"
              >多桌点餐</a-button
            >
            <a-button
              type="primary"
              @click="accountSettle"
              :disabled="!canSettle"
              >结账</a-button
            >
            <a-button type="primary" @click="antiSettle" v-if="canAntiSettle"
              >反结</a-button
            >
            <a-button @click="$router.push({ name: 'RestaurantIndex' })"
              >返回</a-button
            >
          </div>
        </a-layout-content>
      </a-layout>
    </a-spin>
    <a-modal
      :width="755"
      :visible="showMoreFoodCookingMethod"
      title="做法"
      @ok="onMoreFoodCookingMethodSubmit"
      @cancel="showMoreFoodCookingMethod = false"
    >
      <div class="cooking-method all">
        <ul>
          <li
            v-for="item in foodCookingMethodAll"
            :key="item.Id"
            :class="[
              {
                check:
                  foodCookingMethodAllSelectedIds &&
                  foodCookingMethodAllSelectedIds.includes(item.Id)
              }
            ]"
            @click="onFoodCookingMethodAllClick(item)"
          >
            {{ item.Text }}
            <a-icon type="check" class="check-icon" />
          </li>
        </ul>
      </div>
    </a-modal>
    <ReturnDish
      ref="ReturnDish"
      @update="updateDetail"
      @submit="getReturnDish"
    ></ReturnDish>
    <ConfirmDish ref="ConfirmDish" @update="updateDetail"></ConfirmDish>
    <MoreOpertion
      ref="MoreOpertion"
      @update="updateDetail"
      @cancelOrder="cancelOrder"
    ></MoreOpertion>
    <AccountSettle ref="AccountSettle" @update="fetchOrderData"></AccountSettle>
    <PayResult ref="PayResult"></PayResult>
    <multTableOrder
      ref="multTableOrder"
      :isChooseTable="isChooseTable"
      :title="tableTitle"
      @update="fetchOrderData"
      @submit="getTableIds"
    />
    <EditInfo ref="EditInfo" @submit="fetchOrderData"></EditInfo>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { DataGrid } from "@/components/dataGrid";
import promptModal from "@/components/promptModal";
import ReturnDish from "./ReturnDish";
import ConfirmDish from "./ConfirmDish";
import MoreOpertion from "./MoreOpertion";
import multTableOrder from "./multTableOrder";
import AccountSettle from "./AccountSettle";
import PayResult from "./PayResult";
import EditInfo from "./EditInfo";
import { cache, accAdd, accMul } from "@/utils/common";
import editFoodPackModal from "./editFoodPackModal";
import FoodSelect from "./foodSelect/foodSelect";
import {
  ReportDetailModal,
  MemberListModal
} from "@/views/roommanage/index.js";
import "./rms.less";
import "./orderFood.less";
export default {
  components: {
    DataGrid,
    ReturnDish,
    ConfirmDish,
    MoreOpertion,
    AccountSettle,
    multTableOrder,
    FoodSelect,
    PayResult,
    EditInfo
  },
  data() {
    return {
      user: null,
      orderColumns: [
        {
          title: "菜名",
          dataIndex: "AccountItemName",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "数量",
          dataIndex: "Quantity",
          width: 50,
          align: "center"
        },
        {
          title: "单价",
          dataIndex: "UnitPrice",
          width: 70,
          align: "center"
        },
        {
          title: "金额",
          dataIndex: "TotalPrice",
          width: 70,
          align: "center"
        },
        {
          title: "折扣",
          dataIndex: "DiscountPrice",
          width: 50,
          align: "center"
        },
        {
          title: "核算金额",
          dataIndex: "FinalPrice",
          width: 75,
          align: "center",
          customRender: (text, record) => {
            // icon-daiqueren
            if (record.IsUnconfirmed) {
              return (
                <div>
                  {{ text }}
                  <a-icon type="schedule" class="un-confirm" title="待确认" />
                </div>
              );
            } else {
              return <div>{{ text }}</div>;
            }
          }
        }
      ],
      orderTableProps: {
        scroll: { x: false, y: "calc(100vh - 405px)" },
        locale: { emptyText: "请选择右侧菜品点菜" }
      },
      printerTableProps: {
        scroll: { x: false, y: "calc(100vh - 320px)" }
      },
      foodSelectWraperWidth: "",
      orderFoodList: [],
      foodClassKey: 0,
      orderData: {},
      tbaleNames: [],
      OrderStatus: "",
      OrderStatusName: "",
      currentTableData: [],
      totalData: {},
      loading: false,
      // 快捷可选的做法，最多4个
      foodCookingMethod: [],
      // 所有可选的做法
      foodCookingMethodAll: [],
      // 已点菜品表格当前选中的行
      currentSelectedRow: {},
      // 是否显示快捷可选做法
      showFoodCookingMethod: false,
      // 是否显示更多做法弹窗
      showMoreFoodCookingMethod: false,
      // 所有做法弹窗中选中的ids
      foodCookingMethodAllSelectedIds: [],
      // IsGiveStatus: false,
      openTableList: [],

      isChooseTable: false,
      tableTitle: "",
      canSettle: true,
      canOrder: true,
      canAntiSettle: false,
      isAntiStatus: false,
      canCancel: true,
      // PrintType: 0,
      printerFoods: [],
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      showFoods: false,
      //是否存在待确认菜品
      hasUnConfirm: false,
      //是否是会员点餐
      isMemberOrder: false,
      member: {},
      billPrintData: {}
    };
  },
  computed: {
    gridColumns() {
      const num = Math.round(this.foodSelectWraperWidth / 160);
      let columns = "";
      for (let i = 0; i < num; i++) {
        columns = `${columns} 1fr`;
      }
      return columns;
    },
    tableScroll() {
      let h = "calc(100vh - 405px)";
      if (this.showFoodCookingMethod) {
        h = "calc(100vh - 475px)";
      }
      const orderTable = this.$refs.orderTable;
      if (orderTable && orderTable.$el) {
        const tableBody = orderTable.$el.getElementsByClassName(
          "ant-table-body"
        );
        tableBody[0].style.maxHeight = h;
      }
      return { x: false, y: h };
    },
    printerFoodList() {
      return this.orderFoodList.filter(el => el.Id && !el.IsUnconfirmed);
    }
  },
  created() {
    this.user = cache.get("user");
    this.init();
  },

  methods: {
    //选择会员卡
    handleMemberCardNo() {
      const { routeQuery } = this;
      const that = this;
      MemberListModal({
        isNeedPass: true,
        option: {
          MemberCardId: that.orderData.MemberCardId
        },
        update: data => {
          this.$post("EditRestaurantOrder", {
            OrderId: routeQuery.orderId,
            MemberId: data.Id,
            MemberName: data.Name
          }).then(res => {
            if (res.Data) {
              const _this = this;
              this.$info({
                title: "提示",
                content: res.Data,
                onOk() {
                  _this.init();
                }
              });
            } else {
              this.init();
            }
          });
        }
      });
    },
    accountSettle() {
      this.$refs.AccountSettle.show(this.routeQuery.orderId);
    },
    updateDetail() {
      this.init();
      this.currentSelectedRow = {};
    },
    init() {
      this.isChooseTable = false;
      this.routeQuery = this.$route.query;
      if (!this.routeQuery.orderId) {
        this.$message.error("缺少必要参数");
        this.$router.push({
          name: "RestaurantIndex"
        });
        return;
      }
      this.fetchOrderData();
      this.fetchCookingMethodData();
    },
    getBillPrintData() {
      return new Promise(resolve => {
        this.$post("Get_BillPrintGuest", { Type: 1 }).then(result => {
          this.billPrintData = result.Data;
          this.billPrintData.Id = 1;
          resolve();
        });
      });
    },
    fetchOrderData() {
      return new Promise(resolve => {
        this.$post("Rest_GetOrderDetail", {
          Id: this.routeQuery.orderId
        }).then(res => {
          this.orderData = res.Data;
          this.member = {
            Id: res.Data.MemberCardId,
            Name: res.Data.MemberName
          };
          this.isMemberOrder = res.Data.MemberCardId ? true : false;
          const tbaleNames = res.Data.DishTables.map(p => p.TableName);
          this.tbaleNames = tbaleNames;
          this.openTableList = res.Data.DishTables;
          if (this.routeQuery.tableId) {
            this.currentTableData = res.Data.DishTables.find(
              item => item.TableId === this.routeQuery.tableId
            );
            this.tbaleNames = [this.currentTableData.TableName];
            this.OrderStatus = this.currentTableData.OrderStatus;
            this.OrderStatusName = this.currentTableData.OrderStatusName;
            this.hasUnConfirm = this.currentTableData.DishAccounts.some(
              el => el.IsUnconfirmed
            );
            this.canAntiSettle =
              this.currentTableData.OrderStatus == 2 && res.Data.Status != 4;
            this.canCancel =
              this.currentTableData.OrderStatus == 1 &&
              res.Data.Status != 12 &&
              res.Data.Status != 4;
            this.canOrder =
              this.currentTableData.OrderStatus != 2 &&
              res.Data.Status != 2 &&
              res.Data.Status != 4;
          } else {
            this.OrderStatus = this.orderData.Status;
            this.OrderStatusName = this.orderData.StatusName;
            this.currentTableData = res.Data.DishTables[0];
            this.canAntiSettle =
              res.Data.DishTables.some(el => el.OrderStatus == 2) &&
              res.Data.Status != 4;
            this.canCancel =
              res.Data.DishTables.some(el => el.OrderStatus == 1) &&
              res.Data.Status != 12 &&
              res.Data.Status != 4;
            this.canOrder =
              res.Data.DishTables.some(el => el.OrderStatus != 2) &&
              res.Data.Status != 2 &&
              res.Data.Status != 4;
            for (let i = 0; i < res.Data.DishTables.length; i++) {
              const item = res.Data.DishTables[i];
              this.hasUnConfirm = item.DishAccounts.some(
                el => el.IsUnconfirmed
              );
              if (this.hasUnConfirm) {
                break;
              }
            }
          }
          if (
            res.Data.Status != 4 &&
            res.Data.Status != 2 &&
            !this.hasUnConfirm
          ) {
            if (res.Data.Payments && res.Data.Payments.length) {
              this.canSettle = true;
            } else {
              const data = res.Data.DishTables.filter(
                el => el.OrderStatus == 1 || el.OrderStatus == 12
              );
              if (data && data.length) {
                this.canSettle = data.some(
                  el => el.DishAccounts && el.DishAccounts.length
                );
              } else {
                this.canSettle = false;
              }
            }
          } else {
            this.canSettle = false;
          }
          this.orderFoodList = cloneDeep(
            this.currentTableData.DishAccounts
          ).map(p => {
            p._id = p.Id;
            p.CookingMethodIds = [];
            return p;
          });
          this.totalPrice();
          this.currentSelectedRow = {};
          resolve(res.Data);
          setTimeout(() => {
            if (this.hasUnConfirm) {
              this.confirmDish();
            }
          }, 100);
        });
      });
    },
    fetchCookingMethodData() {
      this.$post("Common_GetSelect", {
        Types: "CookingMethod"
      }).then(res => {
        this.foodCookingMethodAll = res.Data.CookingMethod;
        this.foodCookingMethod = this.foodCookingMethodAll.filter(
          (p, index) => index < 4
        );
      });
    },
    totalPrice() {
      const { orderData, routeQuery } = this;
      const totalData = {
        quantity: 0,
        tablePrice: 0,
        totalPrice: 0,
        finalPrice: 0,
        orderTotalAmount: 0,
        orderFinalAmount: 0,
        orderSettleAmount: 0
      };
      for (let i = 0; i < this.orderFoodList.length; i++) {
        const item = this.orderFoodList[i];
        totalData.quantity = accAdd(totalData.quantity, item.Quantity);
        totalData.totalPrice = accAdd(totalData.totalPrice, item.TotalPrice);
        totalData.finalPrice = accAdd(totalData.finalPrice, item.FinalPrice);
      }
      const otherTable = this.openTableList.filter(
        el => el.TableId != this.currentTableData.TableId
      );
      let totalAmount = 0,
        totalFinal = 0;
      if (otherTable && otherTable.length) {
        otherTable.forEach(el => {
          el.DishAccounts.forEach(item => {
            totalAmount = accAdd(totalAmount, item.TotalPrice);
            totalFinal = accAdd(totalFinal, item.FinalPrice);
          });
          if (
            routeQuery &&
            !routeQuery.tableId &&
            orderData.DishTables.length > 1
          ) {
            const list = this.orderFoodList.filter(el => !el.Id);
            if (el.OrderStatus != 2) {
              let total = 0,
                final = 0;
              list.forEach(el => {
                total = accAdd(total, el.TotalPrice);
                final = accAdd(final, el.FinalPrice);
              });
              totalAmount = accAdd(totalAmount, total);
              totalFinal = accAdd(totalFinal, final);
            }
          }
        });
      }
      totalData.orderTotalAmount = accAdd(totalAmount, totalData.totalPrice);
      totalData.orderFinalAmount = accAdd(totalFinal, totalData.finalPrice);
      totalData.orderSettleAmount = accAdd(
        totalData.orderFinalAmount,
        orderData.FreeRemnantAmount
      );
      this.totalData = totalData;
    },

    setOrderTableToBottom() {
      const orderTable = this.$refs.orderTable;
      const el = orderTable.$el;
      const tableBody = el.getElementsByClassName("ant-table-body");
      if (tableBody && tableBody.length) {
        setTimeout(() => {
          tableBody[0].scrollTop = tableBody[0].scrollHeight;
        }, 10);
      }

      // var ele = document.getElementById('id');
      // ele.scrollTop = ele.scrollHeight;
    },
    addFood(item) {
      const { orderData } = this;
      if (orderData.Status != 1 && orderData.Status != 12) {
        this.$message.error(`当前订单状态为 ${orderData.StatusName} 不能点菜`);
        return false;
      }
      if (item.IsSoldOut || item.Status == 0) {
        return;
      }
      // const giveStatus = this.$refs.FoodSelect.getGiveStatus();
      // if (giveStatus) {
      //   price = 0;
      //   // this.IsGiveStatus = false;
      //   this.setGiveStatus(false);
      // }
      const isExzist = this.orderFoodList.find(
        el =>
          el.AccountItemId == item.DishId &&
          !el.CookingMethodDesc &&
          !el.CookingMethodIds.length &&
          !el.Id
      );
      if (isExzist) {
        isExzist.Quantity = accAdd(isExzist.Quantity, 1);
        isExzist.TotalPrice = accMul(isExzist.UnitPrice, isExzist.Quantity);
        isExzist.FinalPrice = isExzist.TotalPrice;
        this.currentSelectedRow = isExzist;
        this.$refs.orderTable.setGridData(isExzist);
      } else {
        const price =
          this.isMemberOrder && item.MemberUnitPrice != null
            ? item.MemberUnitPrice
            : item.UnitPrice;
        const row = {
          _id: new Date().getTime() + parseInt(Math.random() * 1000),
          AccountItemId: item.DishId,
          AccountItemName: item.DishName,
          UnitPrice: price,
          Quantity: 1,
          TotalPrice: price,
          DiscountPrice: 0,
          FinalPrice: price,
          CookingMethodIds: [],
          PracticeDesc: "",
          CookingMethodDesc: "",
          IsPack: item.IsPack,
          PackDetails: item.PackDetails
        };
        this.orderFoodList.push(row);
        this.currentSelectedRow = row;
        this.$refs.orderTable.setGridData(row);
        this.setOrderTableToBottom();
      }
      this.showFoodCookingMethod = true;
      this.totalPrice();
    },
    onOrderTableSelectedRow(row) {
      if (!row || row.Id) {
        this.showFoodCookingMethod = false;
      }
      this.currentSelectedRow = row;
    },
    // onPrinter() {
    //   // this.PrintType = 0;
    //   if (this.$refs.printerTable) {
    //     this.$refs.printerTable.setSelecteds([]);
    //   }
    // },
    onPrintReport(code, title) {
      if (code) {
        const serverUrl = this.$config.serverUrl;
        let url =
          this.user.ReportUrl +
          "/show?reportid=" +
          code +
          "&orderId=" +
          this.routeQuery.orderId +
          "&url=" +
          serverUrl.substring(
            serverUrl.lastIndexOf("//") + 2,
            serverUrl.length
          ) +
          "&Token=" +
          this.user.Token;
        if (this.billPrintData.Id) {
          this.printDetail(title, url);
        } else {
          this.getBillPrintData().then(() => {
            this.printDetail(title, url);
          });
        }
        // ReportDetailModal({
        //   title: title + "信息",
        //   width: "90%",
        //   url: url
        // });
      }
    },
    printDetail(title, url) {
      //不打印备注
      if (!this.billPrintData.PrintRemark) {
        url = url + "&isNoRemark=1";
      }
      // 不直接预览打印
      if (!this.billPrintData.PrintPreview) {
        url = url + "&isprint=1";
        ReportDetailModal({
          title: "报表信息",
          width: "90%",
          url: url,
          openModal: false
        });
        return false;
      }
      ReportDetailModal({
        title: title + "信息",
        width: "90%",
        url: url
      });
    },
    selectFoods() {
      this.printerFoods = this.$refs.printerTable.getSelecteds();
      if (!this.printerFoods || !this.printerFoods.length) {
        this.$message.error("请选择打印菜品");
        this.showFoods = true;
        return false;
      }
      this.showFoods = false;
      // this.PrintType = 8;
      this.onPrinter(8);
    },
    onPrinter(printType) {
      const { routeQuery, $post, $message } = this;

      const json = {
        OrderId: routeQuery.orderId
      };
      if (printType == 0 || printType == 1) {
        json.PrintType = printType;
      } else {
        const ids = this.printerFoods.map(v => v.Id);
        json.AccountIds = ids;
      }
      $post("RMS_Print", json).then(() => {
        $message.success("打印成功");
        if (this.$refs.printerTable) {
          this.$refs.printerTable.setSelecteds([]);
        }
      });
    },
    onSubmit(type) {
      const {
        routeQuery,
        currentTableData,
        orderFoodList,
        orderData,
        $post
      } = this;
      // this.loading = true;
      let json = {
        OrderId: routeQuery.orderId,
        IsPrint: type == 2 ? true : false,
        Tables: []
      };
      const orderList = orderFoodList.filter(el => !el.Id);
      if (orderList && !orderList.length) {
        this.$message.info("请先选择菜品");
        return false;
      }
      if (routeQuery.tableId || orderData.DishTables.length === 1) {
        // 单台点菜
        json.Tables = [
          {
            TableId: currentTableData.TableId,
            TableName: currentTableData.TableName,
            Dishes: orderList
          }
        ];
      } else if (orderData.DishTables.length) {
        // 多台
        for (let i = 0; i < orderData.DishTables.length; i++) {
          const item = orderData.DishTables[i];
          if (item.OrderStatus != 2) {
            json.Tables.push({
              TableId: item.TableId,
              TableName: item.TableName,
              Dishes: orderList
            });
          }
        }
      }
      // return false;
      const _this = this;
      $post("RMS_OrderDish", json, { alertError: false })
        .then(() => {
          this.loading = false;
          this.$confirm({
            title: "点餐成功",
            okText: "继续操作",
            cancelText: "返回工作台",
            onOk() {
              _this.updateDetail();
              _this.$refs.FoodSelect.init();
            },
            onCancel() {
              _this.$router.push({ name: "RestaurantIndex" });
            }
          });
        })
        .catch(error => {
          //下单成功但打印因失败
          if (type == 2 && error.data && error.data.Code == 2) {
            this.$confirm({
              title: "点餐成功",
              content: () => <div style="color:#f60">{error.data.Message}</div>,
              okText: "继续操作",
              cancelText: "返回工作台",
              onOk() {
                _this.updateDetail();
              },
              onCancel() {
                _this.$router.push({ name: "RestaurantIndex" });
              }
            });
          } else {
            const text =
              error.data && error.data.Message
                ? error.data.Message
                : "后台发生错误！";
            _this.$message.error(text, 5);
          }
          this.loading = false;
        });
    },
    closeCookingMethodBox() {
      this.showFoodCookingMethod = false;
    },
    addMethod() {
      const { currentSelectedRow } = this;

      if (!currentSelectedRow._id) {
        this.$message.warning("请选择菜品");
        return;
      }
      promptModal({
        title: "手写做法",
        type: "a-input",
        inputProps: {
          placeholder: "请输入做法",
          defaultValue: currentSelectedRow.CookingMethodDesc
        },
        submit: val => {
          currentSelectedRow.CookingMethodDesc = val;
          return true;
        }
      });
    },
    onFoodCookingMethodClick(item) {
      const { currentSelectedRow, foodCookingMethodAll } = this;
      if (
        currentSelectedRow &&
        currentSelectedRow.CookingMethodIds &&
        currentSelectedRow.CookingMethodIds.includes(item.Id)
      ) {
        currentSelectedRow.CookingMethodIds = currentSelectedRow.CookingMethodIds.filter(
          p => p != item.Id
        );
      } else if (currentSelectedRow.CookingMethodIds) {
        currentSelectedRow.CookingMethodIds.push(item.Id);
      } else {
        currentSelectedRow.CookingMethodIds = [item.Id];
      }
      currentSelectedRow.PracticeDesc = foodCookingMethodAll
        .filter(p => currentSelectedRow.CookingMethodIds.includes(p.Id))
        .map(p => p.Text)
        .join("");
    },
    onFoodCookingMethodAllClick(item) {
      const { foodCookingMethodAllSelectedIds } = this;
      if (foodCookingMethodAllSelectedIds.includes(item.Id)) {
        this.foodCookingMethodAllSelectedIds = foodCookingMethodAllSelectedIds.filter(
          p => p != item.Id
        );
      } else {
        foodCookingMethodAllSelectedIds.push(item.Id);
      }
    },
    openMoreFoodCookingMethodModal() {
      let { currentSelectedRow } = this;
      this.showMoreFoodCookingMethod = true;
      if (currentSelectedRow.CookingMethodIds) {
        this.foodCookingMethodAllSelectedIds = cloneDeep(
          currentSelectedRow.CookingMethodIds
        );
      } else {
        this.foodCookingMethodAllSelectedIds = [];
      }
    },
    // 更多菜品做法弹窗提交
    onMoreFoodCookingMethodSubmit() {
      const {
        currentSelectedRow,
        foodCookingMethodAllSelectedIds,
        foodCookingMethodAll
      } = this;
      currentSelectedRow.CookingMethodIds = foodCookingMethodAllSelectedIds;
      this.showMoreFoodCookingMethod = false;
      currentSelectedRow.PracticeDesc = foodCookingMethodAll
        .filter(p => currentSelectedRow.CookingMethodIds.includes(p.Id))
        .map(p => p.Text)
        .join("");
    },
    // 显示菜品做法快捷选择框
    setShowFoodCookingMethod(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      this.showFoodCookingMethod = true;
      this.setOrderTableToBottom();
    },
    //赠送菜品
    giveFoods() {
      // this.IsGiveStatus = true;
      // this.setGiveStatus(true);
      const { currentSelectedRow } = this;
      if (currentSelectedRow) {
        currentSelectedRow.UnitPrice = 0;
        currentSelectedRow.TotalPrice = 0;
        currentSelectedRow.DiscountPrice = 0;
        currentSelectedRow.FinalPrice = 0;
      } else {
        this.$message.warning("请选择赠送菜品");
      }
      this.totalPrice();
    },
    //退菜
    returnFoods(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;

      if (this.openTableList && this.openTableList.length) {
        this.$refs.ReturnDish.show(
          currentSelectedRow,
          this.openTableList,
          "returnFoods"
        );
      } else if (this.openTableList && this.openTableList.length == 1) {
        // promptModal({
        //   title: "退菜数量",
        //   type: "a-input-number",
        //   inputProps: {
        //     placeholder: "请输入数字",
        //     defaultValue: 1,
        //     max: currentSelectedRow.Quantity
        //   },
        //   submit: val => {
        //     _this
        //       .$post(
        //         "ReturnDish",
        //         {
        //           AccountIds: [currentSelectedRow.Id],
        //           Num: -val
        //         },
        //         { alertError: false }
        //       )
        //       .then(res => {
        //         _this.$message.success("操作成功");
        //         _this.updateDetail();
        //         return true;
        //       })
        //       .catch(error => {
        //         if (error.data && error.data.Code == 2) {
        //           this.$info({
        //             title: "退菜成功",
        //             content: h => (
        //               <div style="color:#f60">{error.data.Message}</div>
        //             ),
        //             onOk() {
        //               _this.updateDetail();
        //             }
        //           });
        //         } else {
        //           const text =
        //             error.data && error.data.Message
        //               ? error.data.Message
        //               : "后台发生错误！";
        //           _this.$message.error(text, 5);
        //         }
        //       });
        //   }
        // });
      }
    },
    getReturnDish(accountItemIds, Num, type, Reason) {
      const { $post, $message } = this;
      if (type == "returnFoods") {
        if (!accountItemIds.length) {
          $message.info(
            "该菜品在已选桌台已退菜成功，如果还能看到该菜品，此菜品存在于其他桌台",
            5
          );
          return false;
        }
        const _this = this;
        $post(
          "ReturnDish",
          {
            AccountIds: accountItemIds,
            Num: -Num,
            Reason: Reason
          },
          { alertError: false }
        )
          .then(() => {
            $message.success("操作成功");
            this.updateDetail();
          })
          .catch(error => {
            if (error.data && error.data.Code == 2) {
              this.$info({
                title: "退菜成功",
                content: () => (
                  <div style="color:#f60">{error.data.Message}</div>
                ),
                onOk() {
                  _this.updateDetail();
                }
              });
            } else {
              const text =
                error.data && error.data.Message
                  ? error.data.Message
                  : "后台发生错误！";
              _this.$message.error(text, 5);
            }
          });
      } else if (type == "editPrice") {
        if (!accountItemIds.length) {
          $message.info(
            "该菜品价格在已选桌台已修改成功，如果看到的价格未改变，此价格菜品存在于其他桌台"
          );
          return false;
        }
        $post("RMS_EditPriceAsync", {
          AccountIds: accountItemIds,
          UnitPrice: Num
        }).then(res => {
          this.orderData = res.Data;
          this.openTableList = res.Data.DishTables;
          this.setPrice(Num);
        });
      }
    },
    // 增加菜品数量
    addQuantity(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;
      currentSelectedRow.Quantity = currentSelectedRow.Quantity + 1;
      currentSelectedRow.TotalPrice = accMul(
        currentSelectedRow.UnitPrice,
        currentSelectedRow.Quantity
      );
      currentSelectedRow.FinalPrice = currentSelectedRow.TotalPrice;
      this.totalPrice();
    },
    // 减少菜品数量
    cutQuantity(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;
      const that = this;
      if (currentSelectedRow.Quantity == 1) {
        this.$confirm({
          title: "你确认删除选中菜品吗?",
          onOk() {
            that.orderFoodList = that.orderFoodList.filter(
              p => p._id !== currentSelectedRow._id
            );
            that.showFoodCookingMethod = false;
            if (that.orderFoodList && that.orderFoodList.length) {
              that.currentSelectedRow =
                that.orderFoodList[that.orderFoodList.length - 1];
              that.$refs.orderTable.setGridData(that.currentSelectedRow);
              if (!that.currentSelectedRow.Id) {
                that.showFoodCookingMethod = true;
              }
            } else {
              that.currentSelectedRow = {};
              that.showFoodCookingMethod = false;
            }
            that.setOrderTableToBottom();
            that.totalPrice();
          },
          onCancel() {}
        });
      } else {
        currentSelectedRow.Quantity = currentSelectedRow.Quantity - 1;
        currentSelectedRow.TotalPrice = accMul(
          currentSelectedRow.UnitPrice,
          currentSelectedRow.Quantity
        );
        currentSelectedRow.FinalPrice = currentSelectedRow.TotalPrice;
        this.totalPrice();
      }
    },
    //删除
    delRow(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;
      this.orderFoodList = this.orderFoodList.filter(
        p => p._id !== currentSelectedRow._id
      );
      this.showFoodCookingMethod = false;
      if (this.orderFoodList && this.orderFoodList.length) {
        this.currentSelectedRow = this.orderFoodList[
          this.orderFoodList.length - 1
        ];
        this.$refs.orderTable.setGridData(this.currentSelectedRow);
        if (!this.currentSelectedRow.Id) {
          this.showFoodCookingMethod = true;
        }
      } else {
        this.currentSelectedRow = {};
        this.showFoodCookingMethod = false;
      }
      this.setOrderTableToBottom();
      this.totalPrice();
    },
    // 改价
    editPrice(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow, $post } = this;
      if (
        this.openTableList &&
        this.openTableList.length > 1 &&
        currentSelectedRow.Id
      ) {
        this.$refs.ReturnDish.show(
          currentSelectedRow,
          this.openTableList,
          "editPrice"
        );
      } else {
        promptModal({
          title: "修改价格",
          type: "a-input-number",
          inputProps: {
            placeholder: "请输入价格",
            defaultValue: currentSelectedRow.UnitPrice
          },
          submit: val => {
            if (currentSelectedRow.Id) {
              $post("RMS_EditPriceAsync", {
                AccountId: currentSelectedRow.Id,
                UnitPrice: val
              }).then(() => {
                this.setPrice(val);
              });
            } else {
              this.setPrice(val);
            }
            return true;
          }
        });
      }
    },
    setPrice(val) {
      const { currentSelectedRow } = this;
      currentSelectedRow.UnitPrice = val;
      currentSelectedRow.TotalPrice = accMul(
        currentSelectedRow.UnitPrice,
        currentSelectedRow.Quantity
      );
      currentSelectedRow.FinalPrice = currentSelectedRow.TotalPrice;

      this.totalPrice();
    },
    // 修改数量
    editQuantity(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;
      promptModal({
        title: "修改数量",
        type: "a-input-number",
        inputProps: {
          placeholder: "请输入数字",
          defaultValue: currentSelectedRow.Quantity
        },
        submit: val => {
          currentSelectedRow.Quantity = val;
          currentSelectedRow.TotalPrice = accMul(
            currentSelectedRow.UnitPrice,
            currentSelectedRow.Quantity
          );
          currentSelectedRow.FinalPrice = currentSelectedRow.TotalPrice;
          this.totalPrice();
          return true;
        }
      });
    },

    // 多桌点餐
    multTableOrder() {
      this.isChooseTable = false;
      this.tableTitle = "多桌点餐";
      const { currentSelectedRow, orderFoodList, orderData } = this;
      const orderList = orderFoodList.filter(el => !el.Id);
      if (!orderList.length) {
        this.$message.error("请先选择菜品");
        return false;
      }
      // orderData.DishTables = orderData.DishTables.filter(
      //   el => el.OrderStatus == 1
      // );
      const data = cloneDeep(orderData);
      data.DishTables = data.DishTables.filter(el => el.OrderStatus != 2);
      this.$refs.multTableOrder.show(currentSelectedRow, orderList, data);
    },
    // 取消订单
    cancelOrder() {
      const { routeQuery, orderData, tbaleNames } = this;
      const _this = this;
      if (routeQuery.tableId || orderData.DishTables.length == 1) {
        let tableId = routeQuery.tableId
          ? routeQuery.tableId
          : orderData.DishTables[0].TableId;
        let tableName = routeQuery.tableId
          ? tbaleNames[0]
          : orderData.DishTables[0].TableName;
        this.$confirm({
          title: "确定取消桌台 【" + tableName + "】 吗？",
          onOk() {
            _this.submitCancel([tableId]);
          }
        });
      } else {
        // orderData.DishTables = orderData.DishTables.filter(
        //   el => el.OrderStatus == 1
        // );
        const data = cloneDeep(orderData);
        data.DishTables = data.DishTables.filter(el => el.OrderStatus == 1);
        if (orderData.DishTables.length) {
          this.isChooseTable = true;
          this.isAntiStatus = false;
          this.tableTitle = "选择桌台";
          this.$refs.multTableOrder.show({}, [], data);
        }
      }
    },
    submitCancel(ids) {
      const { $post, routeQuery } = this;
      $post("Rest_CancelOrder", {
        Id: routeQuery.orderId,
        TableIds: ids
      }).then(() => {
        this.$message.success("桌台取消成功");
        this.$router.push({ name: "RestaurantIndex" });
      });
    },
    getTableIds(ids) {
      if (this.isAntiStatus) {
        this.submitAntiSettle(ids);
      } else {
        this.submitCancel(ids);
      }
    },
    antiSettle() {
      const { routeQuery, orderData, tbaleNames } = this;
      const _this = this;
      if (routeQuery.tableId || orderData.DishTables.length == 1) {
        let tableId = routeQuery.tableId
          ? routeQuery.tableId
          : orderData.DishTables[0].TableId;
        let tableName = routeQuery.tableId
          ? tbaleNames[0]
          : orderData.DishTables[0].TableName;
        this.$confirm({
          title: "确定反结桌台 【" + tableName + "】 吗？",
          onOk() {
            _this.submitAntiSettle([tableId]);
          }
        });
      } else {
        // orderData.DishTables = orderData.DishTables.filter(
        //   el => el.OrderStatus == 2
        // );
        const data = cloneDeep(orderData);
        data.DishTables = data.DishTables.filter(el => el.OrderStatus == 2);
        if (this.orderData.DishTables.length) {
          this.isChooseTable = true;
          this.isAntiStatus = true;
          this.tableTitle = "选择桌台";
          this.$refs.multTableOrder.show({}, [], data);
        }
      }
    },
    submitAntiSettle(ids) {
      const { $post, routeQuery } = this;
      $post("RMS_AntiSettle", {
        OrderId: routeQuery.orderId,
        TableIds: ids
      }).then(() => {
        this.$message.success("操作成功");
        this.$refs.multTableOrder.onCancel();
        this.init();
      });
    },
    editPack(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const that = this;
      const { currentSelectedRow } = this;
      editFoodPackModal({
        data: currentSelectedRow.PackDetails,
        submit: data => {
          that.currentSelectedRow.PackDetails = data;
        }
      });
    },
    confirmDish(e) {
      if (
        e &&
        e.target &&
        e.target.getAttribute("class").indexOf("disabled") > -1
      ) {
        return false;
      }
      if (this.routeQuery.tableId) {
        this.$refs.ConfirmDish.show(
          this.routeQuery.orderId,
          this.orderFoodList
        );
      } else {
        this.$refs.ConfirmDish.show(
          this.routeQuery.orderId,
          this.orderFoodList,
          this.orderData
        );
      }
    },
    moreOpertion() {
      this.$refs.MoreOpertion.show(this.routeQuery.orderId, this.orderData, {
        canCancel: this.canCancel
      });
    },
    getOrderQuery() {
      this.$refs.PayResult.show(this.routeQuery.orderId);
    },
    updatePayResult() {
      this.fetchOrderData().then(res => {
        if (res.Status == 2 && res.IsOnlinePay) {
          this.$info({
            title: "订单已结账",
            content: "查询结果为微信支付成功，该订单已自动执行结账处理",
            onOk() {}
          });
        }
      });
    },
    editInfo() {
      this.$refs.EditInfo.show(this.orderData);
    }
  }
};
</script>
<style lang="less" scoped></style>
